import axios from 'axios';
import Morphism from 'morphism';
import Entries from '../models/Entries';

export default class EntryService {
  /**
   * Create a ride
   * @param   {Number} driveId
   * @param   {String} status
   * @param   {Number} latitude
   * @param   {Number} longitude
   * @returns {Promise<Object>}
   */
  static create(driveId, status, latitude, longitude) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/ride/${driveId}/entry`, {
        status,
        latitude,
        longitude,
      }).then((response) => {
        const schema = {
          id: 'id',
          datetime: 'datetime',
          status: 'status',
          latitude: 'point.latitude',
          longitude: 'point.longitude',
        };

        const ride = Morphism(schema, response.data.data, Entries);

        resolve(ride);
      }).catch(reject);
    });
  }
}
